export const EMAIL = 'email';
export const NUMBER = 'number';
export const PASSWORD = 'password';
export const PERCENT = 'percent';
export const PRICE = 'price';
export const TEXT = 'text';
export const TEL = 'tel';
export const YEAR = 'year';
